import { BitkitCloseButton } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Card } from '@chakra-ui/react/card';
import { Text } from '@chakra-ui/react/text';

import { Attachment } from '../TestResults.types';
import Breadcrumb from './components/Breadcrumb';
import AttachmentsTabContent from './tabs/AttachmentsTab/AttachmentsTabContent';
import AttachmentsEmptyState from './tabs/AttachmentsTab/components/AttachmentsEmptyState';

type TestSuiteDetailsProps = {
  name: string;
  breadcrumb?: string;
  attachments?: Attachment[];
  onClose?: () => void;
};

const TestSuiteDetails = ({ name, breadcrumb, attachments, onClose }: TestSuiteDetailsProps) => {
  return (
    <Card.Root position="relative" minH="100%" bg="background/secondary">
      <BitkitCloseButton
        size="md"
        position="absolute"
        insetBlockStart="12"
        insetInlineEnd="12"
        colorVariant="neutral"
        onClick={onClose}
      />

      <Box
        p="16"
        gap="8"
        display="flex"
        flexDir="column"
        overflow="hidden"
        bg="background/primary"
        borderTopRadius="8"
        borderBottom="1px solid"
        borderColor="border/minimal"
      >
        <Breadcrumb breadcrumb={breadcrumb} />
        <Text textStyle="body/lg/semibold">{name}</Text>
      </Box>

      {attachments && attachments.length > 0 ? (
        <Box p="16" gap="8" display="grid" gridTemplateColumns="1fr 1fr 1fr">
          <AttachmentsTabContent attachments={attachments} />
        </Box>
      ) : (
        <AttachmentsEmptyState />
      )}
    </Card.Root>
  );
};

export default TestSuiteDetails;
